export const consignmentItemDefaultValues = {
  quantity: 0,
  weightKg: 0,
};
